import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ApiStandort, StandortClient } from '@api/AffinisDIDApiClient';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService } from '@shared/services/dashboard.service';
import { Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.scss'],
})
export class LocationSearchComponent implements OnInit {
  @Output() public enter = new EventEmitter();

  @Output() public locationIdChange = new EventEmitter();

  public readonly TOOLTIP =
    'Suche nach Standort über die Straße, den Ort, die Postleitzahl, Wirtschaftseinheit oder den technischen Platz.';

  public locationList$: Observable<ApiStandort[]> = of([]);

  public locationListLoading = false;

  public locationListTypeahead$: Subject<string> = new Subject<string>();

  public selectedLocation: ApiStandort | null = null;

  private readonly LOCATION_SUFFIX = 'AD00';

  public constructor(
    public standortClient: StandortClient,
    public dashboardService: DashboardService,
    public translateService: TranslateService
  ) {
    const location = sessionStorage.getItem('location');

    if (location) {
      this.selectedLocation = JSON.parse(location) as ApiStandort;
      this.dashboardService.searchLocationId = this.selectedLocation.wirtschaftseinheit;
    }

    this.dashboardService.weParamSubject.subscribe(we => {
      if (we !== '') {
        this.standortClient.search(we + this.LOCATION_SUFFIX).subscribe(locations => {
          if (locations.length > 0) {
            this.selectedLocation = locations[0];
            sessionStorage.setItem('location', JSON.stringify(this.selectedLocation));
          }
        });
      }
    });
  }

  public loadLocations(): void {
    this.locationList$ = this.locationListTypeahead$.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      tap(() => {
        this.locationListLoading = false;
      }),
      switchMap(term => {
        if (term) {
          this.locationListLoading = true;
          return this.standortClient.search(term).pipe(
            catchError(() => of([])),
            tap(() => {
              this.locationListLoading = false;
            })
          );
        }
        return of([]);
      })
    );
  }

  public ngOnInit(): void {
    this.loadLocations();
  }

  public onChange(location: ApiStandort) {
    if (location) {
      sessionStorage.setItem('location', JSON.stringify(location));
    }

    this.locationIdChange.emit(location.wirtschaftseinheit);
  }

  public resetLocation() {
    this.selectedLocation = null;
    sessionStorage.removeItem('location');
    this.locationIdChange.emit('');
  }
}
